module.exports = __webpack_public_path__ + "static/media/egg.aa2cb10a.webp";